import { Box } from '@chronosphereio/chrono-ui';

interface OptionsEditorTabPanelProps {
  children: React.ReactNode;
  index: number;
  value: number;
}

export function OptionsEditorTabPanel(props: OptionsEditorTabPanelProps) {
  const { children, value, index, ...other } = props;

  const isActive = value === index;

  return (
    <div
      role="tabpanel"
      hidden={!isActive}
      id={`options-editor-tabpanel-${index}`}
      aria-labelledby={`options-editor-tab-${index}`}
      {...other}
    >
      {isActive && <Box mt={2}>{children}</Box>}
    </div>
  );
}
